module.exports = __webpack_public_path__ + "img/c1.3ec404d4.png";